import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import general from './store/general'
import reports from './store/reports'
import server_settings from './store/server_settings'

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['general', 'reports']
    })
  ],
  modules: {
    general,
    reports,
    server_settings
  },
  state: {
    socket: {
      isConnected: false,
      isSubscribed: false,
      message: '',
      reconnectError: false
    }
  },
  mutations: {
    subscribedSocket(state, isSubscribed) {
      state.socket.isSubscribed = isSubscribed
    },
    SOCKET_ONOPEN(state, event) {
      Vue.prototype.$socket = event.currentTarget
      state.socket.isConnected = true
    },
    // eslint-disable-next-line no-unused-vars
    SOCKET_ONCLOSE(state, event) {
      state.socket.isConnected = false
      state.socket.isSubscribed = false
    },
    // eslint-disable-next-line no-unused-vars
    SOCKET_ONERROR(state, event) {
      state.socket.isConnected = false
      state.socket.isSubscribed = false
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
      state.socket.message = message
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      // eslint-disable-next-line no-console
      console.info('SOCKET RECONNECT COUNT:', count)
      state.socket.reconnectError = false
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true
    }
  },
  actions: {
    sendMessage: function(context, message) {
      Vue.prototype.$socket.send(message)
    },
    subscribedSocket({ commit }, isSubscribed) {
      commit('subscribedSocket', isSubscribed)
    }
  }
})
